import React from 'react';
import { motion } from 'framer-motion';
import { RoyalCrown } from './RoyalCrown';
import { RANK_META } from './RankUp';

const LADDER = [['Initiate', 0], ['Knight', 150], ['Champion', 500], ['Sovereign', 1200], ['Emperor', 3000]];
const STEPS = [
  { key: 'pact', label: 'Oath', color: '#D4AF37' },
  { key: 'hits', label: 'Grateful', color: '#5BE08A' },
  { key: 'lock', label: 'Lock', color: '#5DD4FF' },
];

/* Rank ladder + total power + today's three ritual gems → crown. */
export const RankBar = ({ state }) => {
  const done = { pact: !!state.today_pact, hits: state.hits_today > 0, lock: state.locked_today };
  const span = state.next_rank_at ? state.next_rank_at - state.rank_floor : 1;
  const pct = state.next_rank_at ? Math.min(100, ((state.points - state.rank_floor) / span) * 100) : 100;
  const rc = (RANK_META[state.rank] || RANK_META.Initiate).color;
  return (
    <div className="mx-4 mt-3 rounded-2xl px-4 py-3" data-testid="oath-rank-bar"
      style={{ background: 'linear-gradient(135deg, rgba(212,175,55,0.10), rgba(139,63,191,0.12))', border: '1px solid rgba(212,175,55,0.25)' }}>
      <div className="flex items-center justify-between">
        <div>
          <p className="font-['Outfit'] text-[9px] tracking-[0.3em] uppercase text-white/40">Rank</p>
          <p className="font-['Cinzel'] text-base" style={{ color: rc, textShadow: `0 0 10px ${rc}66` }} data-testid="oath-rank">{state.rank}</p>
        </div>
        <div className="flex items-center gap-2">
          {STEPS.map((s) => (
            <motion.span key={s.key} animate={done[s.key] ? { scale: [1, 1.25, 1] } : {}} transition={{ duration: 0.6 }}
              className="w-3 h-3 rotate-45 rounded-[3px]" title={s.label} data-testid={`oath-gem-${s.key}`}
              style={{ background: done[s.key] ? s.color : 'transparent', border: `1px solid ${s.color}`, boxShadow: done[s.key] ? `0 0 10px ${s.color}` : 'none' }} />
          ))}
          <span className="ml-1" data-testid="oath-crown-indicator"><RoyalCrown size={30} dim={!state.crown_today} /></span>
        </div>
        <div className="text-right">
          <p className="font-['Outfit'] text-[9px] tracking-[0.3em] uppercase text-white/40">Total power</p>
          <p className="font-['Outfit'] text-base font-semibold" style={{ color: '#FFE9A0' }} data-testid="oath-points">{state.points}</p>
        </div>
      </div>
      <div className="flex justify-between mt-3 px-0.5">
        {LADDER.map(([name, need]) => {
          const reached = state.points >= need;
          const c = RANK_META[name].color;
          return (
            <div key={name} className="flex flex-col items-center gap-0.5" data-testid={`oath-ladder-${name.toLowerCase()}`}>
              <span className="w-2.5 h-2.5 rounded-full" style={{ background: reached ? c : 'transparent', border: `1px solid ${c}`, boxShadow: name === state.rank ? `0 0 10px ${c}` : 'none' }} />
              <span className="font-['Outfit'] text-[8px] uppercase tracking-[0.08em]" style={{ color: reached ? c : 'rgba(255,255,255,0.3)' }}>{name}</span>
              <span className="font-['Outfit'] text-[8px] text-white/30">{need}</span>
            </div>
          );
        })}
      </div>
      <div className="h-1.5 rounded-full bg-white/10 mt-2 overflow-hidden">
        <motion.div className="h-full rounded-full" initial={{ width: 0 }} animate={{ width: `${pct}%` }} transition={{ duration: 0.9 }}
          style={{ background: `linear-gradient(90deg, ${rc}, #FFE9A0)` }} />
      </div>
      <p className="font-['Outfit'] text-[10px] text-white/45 mt-1.5" data-testid="oath-next-rank-text">
        {state.next_rank ? `${state.points} / ${state.next_rank_at} power → ${state.next_rank}` : 'Emperor — the summit is yours'} · {state.total_crowns} crown{state.total_crowns === 1 ? '' : 's'} forged
      </p>
    </div>
  );
};

export default RankBar;
